import React from 'react'
import { createMuiTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';

export function crateAccountOrganizationTheme(accountOrganization) {
  const styles = createMuiTheme({
    overrides: {
      // Style sheet name ⚛️
      MuiOutlinedInput: {
        root: {
          borderRadius: "0px",
          borderBottomColor: "#EEE",
          borderTopColor: "#EEE",
          borderLeftColor: "#EEE",
          borderRightColor: "#EEE",
        }        
      },
      MuiInput: {
        root: {
          borderRadius: "0px",
          borderBottomColor: "#EEE",
          borderTopColor: "#EEE",
          borderLeftColor: "#EEE",
          borderRightColor: "#EEE",
        }
      },
    },
    palette: {
      primary: {
        main: accountOrganization?.brand_color_1 || "#0ECC46",
      },
      text: {
        primary: {
          main: "#aaa"
        }
      },
      secondary: {
        main: green[500],
      },
    },
  });
  return styles
}

export default function CustomCss(props) {
  const {accountOrganization} = props
  // const accountOrganization = useSelector((state) => state.accountOrganization)

  return <style style={{display:"none"}}>
    {`
      h1, h2, h3, h4 {
        color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      .modal-header {
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
      }
      .btn-ueg.btn-ueg-styled {
        border-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
        color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      .btn-ueg.btn-ueg-styled:hover {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
        border-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      .btn-ueg.btn-ueg-styled:active {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"} !important;
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"} !important;
        border-color: ${accountOrganization?.brand_color_1 || "#0ECC46"} !important;
        box-shadow: none;
      }
      .btn-ueg.btn-ueg-styled:focus, .btn-ueg.btn-ueg-styled:active:focus {
        box-shadow: none !important;
      }
      .btn-ueg.btn-ueg-styled-inverted {
        border-color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
      }
      .btn-ueg.btn-ueg-styled-inverted:hover {
        color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
        background-color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        border-color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
      }
      .btn-ueg.btn-ueg-styled-inverted:active {
        color: ${accountOrganization?.brand_color_1 || "#0ECC46"} !important;
        background-color: ${accountOrganization?.brand_color_2 || "#FFFFFF"} !important;
        border-color: ${accountOrganization?.brand_color_2 || "#FFFFFF"} !important;
        box-shadow: none;
      }
      .btn-ueg.btn-ueg-styled-inverted:focus, .btn-ueg.btn-ueg-styled:active:focus {
        box-shadow: none !important;
      }
      a {
        color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      
      
      
      
      .navigation .nav-elem {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      
      .navigation .nav-elem:hover {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
        opacity: 0.8;
      }
      
      .navigation .nav-elem a {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
      }
      
      .navigation .nav-elem:not(:disabled):not(.disabled):active {
        background-color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        opacity: 0.8;
      }
      
      .navigation .nav-elem:active a {
        color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      
      .direct-messaging .back-button {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      
      .direct-messaging .back-button:hover {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
        opacity: 0.8;
      }
      
      .badge-colored {
        color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
        background-color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
      }
      
      .badge-colored-inverted {
        color: ${accountOrganization?.brand_color_1 || "#0ECC46"};
        background-color: ${accountOrganization?.brand_color_2 || "#FFFFFF"};
      }
    `}
  </style>
}
